import { useEffect, useState } from 'react';
import { Button, Tooltip, message } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import { getStatisticalExportStatus, downloadStatisticalResults } from '../services/api';

export default function StatisticalExportButton({ graphId, jobStatus, size, className }) {
  const [state, setState] = useState({ ready: false });
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    let cancelled = false;
    let timer;
    setState({ ready: false });
    const poll = async () => {
      try {
        const status = await getStatisticalExportStatus(graphId);
        if (cancelled) return;
        setState(status);
        if (!status.complete && !status.error && !status.standardized &&
          (status.mode === 'stats_only' || !['ready', 'failed'].includes(jobStatus))) timer = setTimeout(poll, 5000);
      } catch (error) {
        if (!cancelled) timer = setTimeout(poll, 10000);
      }
    };
    if (graphId) poll();
    return () => { cancelled = true; clearTimeout(timer); };
  }, [graphId, jobStatus]);
  const download = async () => {
    setBusy(true);
    try { await downloadStatisticalResults(graphId); }
    catch (error) { message.error(error.message || 'Unable to download statistical results.'); }
    finally { setBusy(false); }
  };
  return <Tooltip title={state.ready
    ? `${state.rows} result records. ${state.mode === 'stats_only'
      ? `${state.completed_papers}/${state.total_papers} papers complete. ${state.complete ? 'Statistics-only extraction completed.' : 'Completed papers are available now; remaining papers will be appended.'}`
      : state.standardized ? 'Standardized node names included.' : 'Original names available; node cleaning continues.'}`
    : 'Available after the first paper finishes statistical extraction.'}>
    <Button className={className} size={size} icon={<DownloadOutlined />} disabled={!state.ready} loading={busy} onClick={download}>
      Export Statistical Correlations
    </Button>
  </Tooltip>;
}
